import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import _ from 'lodash';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Camera, ArrowDown, IsOpen } from '../../../components/Icon';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { addDocument, deleteDocument } from '../../Documents/actions';
import { addVehicleOption, deleteVehicleProperty, removeVehicleOption, fetchAllOptions } from '../actions';
import { selectWorks } from '../../Api/selectors';
import { selectAllOptions, selectVehicle } from '../selectors';
import { VEHICLE_OPTIONS, VEHICLE_OPTIONS2, VEHICLE_OPTIONS_HOOIKAMMER, VEHICLE_OPTIONS_IDW } from '../constants';
import { REQUEST_INVOICE_FILTER } from '../../Invoices/constants';
import { resizeAndRotate } from '../../../utils/image';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import cn from 'classnames';
import styles from './VehicleOptionsCard.module.css';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

import { Permission } from '../../../components/Permission';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import ImageServiceCarouselComponent from '../../../containers/App/Components/CarouselImageService/CarouselImageService';
import { isMobileDevice } from '../../../utils/checkDevice';
const Container = styled.div`
  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .title {
    margin: 8px 0;
    text-transform: uppercase;
    font-size: 12px;
  }

  width: 100%;
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  .option-container {
    font-weight: 600;
    color: gray;
  }

  .image-available {
    width: 36px;
    height: 36px;
    background-color: #0183d5;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .img {
    width: 100%;
    min-height: 480px;
    background-size: contain;
  }
`;

const ShowButton = styled.span`
  cursor: pointer;
  font-weight: bold;
  font-size: 12px;
  color: #2271d2;
  text-decoration: underline;
  margin-left: 14px;
`;

const STATE = {
  searchString: '',
  editMode: false,
  showAll: false,
  isHBoxCollapsed: true, // Initially, HBox is closed
  showCarousel: false,
  carouselImages: [],
  currentImageId: '',
  isOpen: true,
};

class VehicleOptionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }
  componentDidMount() {
    this.props.fetchAllOptions();
  }

  get vehicleOptions() {
    return env.clientId == AppClientId.INDEWAL
      ? VEHICLE_OPTIONS_IDW
      : env.clientId == AppClientId.HOOIKAMMER
      ? VEHICLE_OPTIONS_HOOIKAMMER
      : VEHICLE_OPTIONS;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          const type = env.clientId === AppClientId.INDEWAL ? `photo_general_${name}` : `photo_option_${name}`;

          console.log('Uploading document with type:', type); // ← Add this line

          this.props.imageUpload(
            {
              name,
              type,
              originalFilename: 'originalFilename',
              file,
            },
            `upload_${name}`,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  toggleHBoxVisibility() {
    this.setState(prevState => ({
      isHBoxCollapsed: !prevState.isHBoxCollapsed,
    }));
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.props.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.props.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  closeCarousel() {
    this.setState({ showCarousel: false, carouselImages: [] });
  }

  setCurrentImage = img => {
    this.setState({ currentImageUrl: img });
  };

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.props.vehicle?.documents?.find(d => d.id === documentId)?.type;
      if (this.props.vehicle?.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;
    const v = this.props.vehicle;
    const photoType = env.clientId === AppClientId.INDEWAL ? 'photo_general' : 'photo_option';

    let index = '';

    let filteredDocuments = [];

    this.vehicleOptions?.forEach((type, i) => {
      if (type?.title) return '';
      let document = v.documents?.find(d => {
        const documentTypeToCompare = d?.type?.toLowerCase();
        const photoTypeToCompare = `${photoType}_${type.toLowerCase()}`;
        return documentTypeToCompare?.indexOf(photoTypeToCompare) === 0;
      });

      if (!document?.id) {
        document = v.documents?.find(d => {
          const documentTypeToCompare = d?.type?.toLowerCase();
          return documentTypeToCompare?.indexOf(`photo_interior_${type.toLowerCase()}`) === 0;
        });
      }
      if (document?.id) {
        filteredDocuments.push(document);
      }
    });

    // if (env.clientId === AppClientId.INDEWAL) {
    //   filteredDocuments = this.props.vehicle.documents?.filter(doc => doc.type?.startsWith('photo_interior_')) || [];
    // } else {
    //   filteredDocuments = this.props.vehicle.documents?.filter(doc => doc.type?.startsWith('photo_option_')) || [];
    // }
    const carouselImages = filteredDocuments.map(doc => ({
      id: doc.id,
      url: doc.url,
    }));

    if (this.state.currentImageId) {
      index = carouselImages?.findIndex(img => img?.id == this.state.currentImageId);
    }

    return (
      <ModalComponent
        size="lg"
        onClose={this.closeCarousel.bind(this)}
        mediumWide
        title={this.lbl('interior.inspection.photos')}
      >
        <ImageServiceCarouselComponent
          imgURLs={carouselImages}
          vehicleId={this.vehicle?.id}
          onDeleteImg={this.handlePhotoDelete}
          onImageChange={this.setCurrentImage}
          currentImageIndex={index}
          onImageClick={currentImage => {
            this.setState({ currentImageId: currentImage });
          }}
        />
      </ModalComponent>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <VBox className={cn('title', styles.gridItemTitle)} key={index}>
          <strong>{this.lbl(`vehicle.options.${value.title}`)} </strong>
        </VBox>
      );

    let options = Array.isArray(this.props.allOptions)
      ? this.props.allOptions.filter(o => o.name.toLowerCase() === value.toLowerCase())
      : [];
    let optionId = options?.[0]?.id;
    let vehicleHasOption;

    for (let i = 0; i < options?.length || 0; i++) {
      for (let j = 0; j < this.props.vehicle.options?.length || 0; j++) {
        let o1 = options[i];
        let o2 = this.props.vehicle.options[j];
        if (o1.id == o2.id && o2.VehicleHasOption?.isSelected) {
          vehicleHasOption = o2;
          optionId = vehicleHasOption.id;
          // if (value == 'airco') {
          //   //
          // }
        }
      }
    }
    //= this.props.vehicle.options?.find((o) => options.find((o2) => o.autotelexId == o2.autotelexId));

    if (value == 'airco') {
      console.dir(options.map(o => o.autotelexId));
      //debugger;
      //
    }
    //

    if (vehicleHasOption) options = this.props.allOptions?.find(o => o.autotelexId == vehicleHasOption.autotelexId);

    //let o1449 = this.props.allOptions?.filter((o) => o.autotelexId == 1449);

    // if (value == 'navigatiesysteem') debugger;

    vehicleHasOption = vehicleHasOption?.VehicleHasOption?.isSelected ? vehicleHasOption : null;

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;

    let photo;

    if (env.clientId === AppClientId.INDEWAL) {
      photo = this.props.vehicle.documents?.find(document => {
        const type = typeof document.type === 'string' ? document.type.toLowerCase() : '';
        return type === `photo_general_${value.toLowerCase()}`;
      });
    } else {
      photo = this.props.vehicle.documents?.find(document => {
        const type = typeof document.type === 'string' ? document.type.toLowerCase() : '';
        return type === `photo_option_${value.toLowerCase()}`;
      });
    }

    if (env.clientId === AppClientId.HOOIKAMMER && !photo?.id) {
      photo = this.props.vehicle.documents?.find(document => {
        const type = typeof document.type === 'string' ? document.type.toLowerCase() : '';
        return type === `photo_interior_${value.toLowerCase()}`;
      });
    }

    let name = `vehicle-option-${optionId}`;
    let width = 100 / 3;
    console.log('Option name:', name);
    if (vehicleHasOption) {
      return (
        <div key={index} className={cn(`option ${!options ? 'inactive' : ''} option-${optionId}`, styles.gridItem)}>
          <div className="option-container">
            <VehiclePropertyLoadable name={name}>
              <CheckboxComponent
                className={styles.checkbox}
                label={value}
                checked={checked}
                onChange={options && this.state.editMode ? () => this.toggleOption(options.id, !checked) : null}
              />
            </VehiclePropertyLoadable>
          </div>

          <VehiclePropertyLoadable name={`upload_${value}`}>
            {photo ? (
              <div
                className="pointer image-available"
                onClick={() => {
                  let container = document.getElementsByClassName('option-inner')[0];
                  let renderOptionPhotoDims = container.getBoundingClientRect();
                  this.setState({
                    renderOptionPhoto: photo.id,
                    currentImageId: photo.id,
                    renderOptionPhotoDims,
                    showCarousel: true,
                  });
                }}
              >
                <Camera />
              </div>
            ) : this.props.weblogin ? (
              <div>
                <Camera />
              </div>
            ) : (
              <div className="pointer" onClick={this.setStateFn({ optionPhoto: options?.id })}>
                <Camera
                  onClick={() =>
                    this.capture(
                      value,
                      this.callback(() => this.props.toggleOption(optionId, true)),
                    )
                  }
                />
              </div>
            )}
          </VehiclePropertyLoadable>
        </div>
      );
    }
  }

  render() {
    if (env.clientId !== AppClientId.INDEWAL && env.clientId !== AppClientId.HOOIKAMMER) {
      return (
        <Container className="option-inner" itemsLength={this.props.invoices?.length}>
          {this.state.showCarousel && this.renderOptionPhoto()}

          <Card style={{ width: '100%' }} className={cn('vehicle-info-card info-card data wide', styles.card)}>
            <HBox vCenter>
              <h2
                className="card-title mb-1 text-muted"
                style={{ cursor: 'pointer' }}
                // onClick={() => this.toggleHBoxVisibility()} // Toggle HBox visibility
              >
                {this.lbl('company.info.data.options')}
              </h2>
            </HBox>
            <div className={cn(styles.gridContainer, { [styles.gridContainerWeblogin]: this.props.weblogin })}>
              {VEHICLE_OPTIONS.map(this.renderOption.bind(this))}
            </div>

            <h2
              className="card-title mb-1 mt-1 text-muted"
              style={{ cursor: 'pointer' }}
              onClick={() => this.toggleHBoxVisibility()} // Toggle HBox visibility
            >
              {this.lbl('company.info.data.options2')} <ArrowDown style={{ paddingLeft: '10px' }} />
            </h2>
            <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>

            <div
              style={{
                display: this.state.isHBoxCollapsed ? 'none' : 'block',
              }}
            >
              <div className={cn(styles.gridContainer, { [styles.gridContainerWeblogin]: this.props.weblogin })}>
                {VEHICLE_OPTIONS2.map(this.renderOption.bind(this))}
              </div>
            </div>
          </Card>
        </Container>
      );
    } else
      return (
        <Container className="option-inner" itemsLength={this.props.invoices?.length}>
          {this.state.showCarousel && this.renderOptionPhoto()}
          <Card className="vehicle-info-card info-card data wide" style={{ width: '100%' }}>
            <HBox vCenter>
              <h2
                style={{ cursor: 'pointer' }}
                onClick={() => this.toggleHBoxVisibility()} // Toggle HBox visibility
              >
                {this.lbl('company.info.data.options')}
              </h2>
              <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            </HBox>
            {this.state.isOpen && (
              <div className={cn(styles.gridContainer, { [styles.gridContainerWeblogin]: this.props.weblogin })}>
                {this.vehicleOptions?.map(this.renderOption.bind(this))}
              </div>
            )}
          </Card>
        </Container>
      );
  }
}

VehicleOptionsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_INVOICE_FILTER]),
    allOptions: selectAllOptions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    fetchAllOptions() {
      dispatch(fetchAllOptions());
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.vehicle.id, optionId, callback));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicle?.id, 'vehicle', documentDto, callback, work));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.vehicle?.id, name));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicle?.id, 'vehicle', id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleOptionsCard = compose(withConnect, withRouter)(VehicleOptionsCardComp);
